var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckedGray400(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91 12.998c-.29 0-.566-.113-.772-.32l-2.181-2.18a1.09 1.09 0 010-1.543 1.088 1.088 0 011.542 0l1.32 1.32 3.601-4.502a1.092 1.092 0 011.704 1.362L8.762 12.59c-.194.242-.481.39-.792.406l-.06.003z",
    fill: "#FFF"
  }))));
}
export default SvgUncheckedGray400;